import type { FavoritesResourcesType } from "@/src/favorites-tab/Favorites.Resources";

export const FavoritesResourcesEn: FavoritesResourcesType = {
    title: "Your favourites",
    tab: {
        all: "All",
        brands: "Brands",
        shoppingMalls: "Shopping Malls",
        offers: "Offers",
    },

    brand: {
        title: "Favourite brands",
        button: "More from brands",
        emptyText: "You don't have favourite brands.",
    },

    shoppingMall: {
        title: "Favourite malls",
        button: "More from malls",
        emptyText: "You don't have favourite malls.",
        mapLinkText: "Show location on map",
    },

    offers: {
        title: "Favourite occasions",
        button: "More from occasions",
        emptyText: "You don't have favourite occasions.",
    },
};
